import React, { useEffect, useRef } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useOutletContext } from "react-router";

gsap.registerPlugin(ScrollTrigger);

const BoxStack = () => {
  const { cmpnyNo, url, homepageInfo } = useOutletContext();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const containerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isMobile) return;

    const boxes = gsap.utils.toArray(".box");

    gsap.set(boxes, {
      opacity: 0,
      y: 100,
    });

    gsap.to(boxes, {
      opacity: 1,
      y: 0,
      duration: 2.2,
      ease: "power1.inOut",
      stagger: {
        each: 0.8,
        onComplete: function () {
          ScrollTrigger.refresh();
        },
      },
      scrollTrigger: {
        trigger: ".inner",
        start: "top 5%",
        end: "top 30%",
        scrub: 1,
      },
    });

    ScrollTrigger.create({
      trigger: ".boxStack",
      start: "top bottom",
      end: "bottom top",
      onEnter: () => {
        document.documentElement.style.overflow = "visible";
        document.body.style.overflow = "visible";
      },
      onLeave: () => {
        document.documentElement.style.overflow = "visible";
        document.body.style.overflow = "visible";
      },
      onEnterBack: () => {
        document.documentElement.style.overflow = "visible";
        document.body.style.overflow = "visible";
      },
      onLeaveBack: () => {
        document.documentElement.style.overflow = "visible";
        document.body.style.overflow = "visible";
      },
    });
  }, [isMobile]);

  const categories = [
    {
      label: "키오스크",
      description: "매장 내 비대면 주문\n및 결제 시스템",
    },
    {
      label: "포스",
      description: "매장 판매, 결제\n재고 관리를 위한 시스템",
    },
    {
      label: "신용카드단말기",
      description: "신용카드 및 모바일\n결제 전용 단말기",
    },
    {
      label: "PG 서비스",
      description: "Payment Gateway\n거래대행 서비스 관리",
    },
  ];

  return (
    <div className="boxStack" ref={containerRef}>
      <div className="inner">
        <div className="info">
          {cmpnyNo === 15922 ? (
            <>
              가장 편리하고
              <br />
              안전한 결제
              <br />
              믿음과 신뢰를 원칙으로
            </>
          ) : (
            <>
              안녕하세요,
              <br />
              {homepageInfo?.cmpnyNm}입니다.
            </>
          )}
        </div>

        {["", "", "", ""].map((_, idx) => {
          const isSm = cmpnyNo === 15922;
          const imageSrc = isSm
            ? `/img/shopTheme/sm_prd_${idx === 3 ? idx + 1 : idx}.png`
            : `/img/shopTheme/simple_card.png`;

          const label = isSm ? categories[idx].label : "인기상품";
          const description = isSm
            ? categories[idx].description
            : "빠르게 변화하는 사회와 트렌드에 신속/ 정확하게 대응합니다.";

          return (
            <div
              key={idx}
              className={`box box-${idx + 1}`}
              onClick={() => navigate(`/shop/${url}/productsList`)}>
              <img src={imageSrc} alt="카드 이미지" />
              <span>{label}</span>
              <p>{description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BoxStack;
